var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('img',{attrs:{"src":_vm.athlete.profile}}),_c('h4',[_vm._v(_vm._s(((_vm.athlete.firstname) + " " + (_vm.athlete.lastname))))])])}
var staticRenderFns = []

export { render, staticRenderFns }